
























// Vue
import { defineComponent, PropType } from '@vue/composition-api'

// model
import { PropOptionRadio } from '@/models'

export default defineComponent({
  name: 'Radio',
  props: {
    value: {
      default: ''
    },
    required: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    id: {
      type: String as PropType<string>
    },
    name: {
      type: String as PropType<string>,
      required: true
    },
    label: {
      type: String as PropType<string>,
      default: ''
    },
    options: {
      type: Array as PropType<PropOptionRadio[]>,
      required: true
    },
    msgError: {
      type: String as PropType<string>,
      default: ''
    },
    hasError: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  }
})
